import { render, staticRenderFns } from "./RolesFormComponent.vue?vue&type=template&id=5b9fa3aa&scoped=true"
import script from "./RolesFormComponent.vue?vue&type=script&lang=js"
export * from "./RolesFormComponent.vue?vue&type=script&lang=js"
import style0 from "./RolesFormComponent.vue?vue&type=style&index=0&id=5b9fa3aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9fa3aa",
  null
  
)

export default component.exports